
import { Container } from "@mui/material";
import { Box, Typography, Divider, Grid, Card, Paper } from "@mui/material";
import ankara from '../../assets/ankara.jpg';
import istanbul from '../../assets/Istanbul.jpg';
import antalya from '../../assets/antalya.jpg';
import tarbzon from '../../assets/Trabzon.jpg';
import sharmElSheikh from '../../assets/Sharm El Sheikh.jpg';
import georgia from '../../assets/georgia.jpg';
import taba from '../../assets/Taba.jpg';
import { useTranslation } from 'react-i18next';
const TravelWith = () => {
  const { t } = useTranslation();
    const travel=[
      {  title: 'Istanbul',
        images: [
          `${istanbul}`,
        ],},
      {  title: 'Antalya',
        images: [
          `${antalya}`,
        ],},
      {  title: 'Tarbzon',
        images: [
          `${tarbzon}`,
        ],},
      {  title: 'Georgia',
        images: [
          `${georgia}`,
        ],},
      {  title: 'Taba',
        images: [
          `${taba}`,
        ],},
      {  title: 'Sharm El Sheikh',
        images: [
          `${sharmElSheikh}`,
        ],},
    ]
  return (
    <Container sx={{width: '100%',minWidth: '100%',backgroundColor: '#ffffff',}} >
      <Box
        id="home"   
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'start',
          alignItems: 'center',
          textAlign: 'center',
          position: 'relative',
          py: 4,
          
        }}
      >
        <Typography
          variant="h2"
          component="div"
          sx={{
            color: '#000000',
            fontWeight: 700,
            fontSize: { xs: '2rem', md: '2.5rem' },
            position: 'relative',
            fontFamily: "Montserrat",
           
          }}
        >
          {t('Titles.travel_with')}
        </Typography>
        <Divider sx={{ backgroundColor: 'primary.main', width: '10vh', height: '2px' ,margin: '20px 0'}} />
      </Box>
      <Grid container spacing={2} sx={{ paddingBottom: '80px'}} >
            {travel.map((project, index) => (
              <Grid item xs={12} sm={12} md={4} key={index} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' ,margin:'15px'}}>
                <Card  sx={{
                  maxWidth: "22.625rem",
                    height: "15.625rem",
                    backgroundColor: "rgba(50, 125, 129, 0.1)",
                    border: "2px solid #327d81",
                    borderRadius: "16px",
                    boxShadow: "0 0 30px rgba(50, 125, 129, 0.8)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-10px)",
                      boxShadow: "0 0 20px rgba(50, 125, 129, 0.8)",
                      backgroundColor: "rgba(50, 125, 129, 0.15)",
                    },
                  }}>
                 
                    {project.images.map((image, index) => (
                      <Paper
                        key={index}
                        elevation={0}
                        sx={{
                          height: "15.625rem",
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: 'transparent',
                          position: 'relative',
                          p: 0
                        }}
                      >
                        <Box
                          component="img"
                          src={image}
                          alt={`${project.title}`}
                          sx={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                          }}
                          onError={(e) => {
                            console.error(`Failed to load image: ${image}`);
                            e.target.src = '/logo192.png';
                          }}
                        />
                      </Paper>
                    ))}
                 
                  
                  </Card>
                  <Typography  component="div" sx={{
                    fontSize: '1.3rem',
                    paddingTop: 2,
                      textAlign: 'center',
                      fontFamily: 'Montserrat',
                      color: '#000000',
                      fontWeight: 600,
                 
                    }}>
                      {t(`${project.title}.title`)}
                    </Typography>
                   
                    </Box>
                </Grid>
                
              ))}
            </Grid>
    </Container>
  );
};

export default TravelWith;  